var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":_vm.value ? false : true,"color":_vm.value ? 'primary' : 'black'},on:{"click":function($event){return _vm.funcao()}}},[_c('v-icon',[_vm._v(" "+_vm._s(this.icon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }